import React from 'react';

const MinimalFooter = () => (
  <footer id="zola-footer" className="zola-footer footer footer-minimal text-center">
    <div className="row">
      <div className="col-xs-12 text-center padding-bottom-2x">
        <small>
          <span >&copy; 2018 Zola, Inc. </span>
          <span className="hidden-xs"> All rights reserved. </span>
          <span className="terms-privacy-links">
            <span><a href="/privacy" target="_blank" rel="noopener noreferrer" >Privacy Policy</a> / </span>
            <span><a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a></span>
            <span className="hidden-xs"> / </span><br className="visible-xs" />
            <span><a href="/webaccessibility" target="_self">Web Accessibility</a> / </span>
            <span><a href="/privacy#CA-privacy-rights" target="_blank" rel="noopener noreferrer" >Your CA Privacy Rights</a></span>
          </span>
        </small>
      </div>
    </div>
  </footer>
);

export default MinimalFooter;



/** WEBPACK FOOTER **
 ** ./src/components/common/footer/MinimalFooter.jsx
 **/